import store from '../store';

export function AuthGuard(to, from, next) {
  if(!store.getters.isLoggedIn)
    next('/'); //validateCookies

  next();
}



// WEBPACK FOOTER //
// ./src/route/guards.js